import React from 'react';

import {
  createTimesheetLineRequest,
  deleteTimesheetLineRequest,
  editTimesheetLineRequest,
  generateNextPayrunRequest,
  getTimesheetAsFileRequest,
  getTimesheetMappingRequest,
  getTimesheetRequest,
  importTimesheetRequest,
  lookupEmployeesRequest,
  reopenTimesheetRequest,
  submitTimesheetRequest,
} from '@vyce/core/src/api/pay';
import { TimesheetPage } from '@vyce/core/src/views/payroll/components/TimesheetPage';

import { useTypedSelector } from '../../hooks';

export const EmployerTimesheetPage: React.FC = () => {
  const { access_token, selectedCompanyAppData } = useTypedSelector(state => state.helper);

  return (
    <TimesheetPage
      locations={selectedCompanyAppData?.locations || []}
      token={access_token}
      getTimesheetMappingRequest={getTimesheetMappingRequest}
      duplicateTimesheetRequest={generateNextPayrunRequest}
      getTimesheetAsFileRequest={getTimesheetAsFileRequest}
      lookupEmployeesRequest={lookupEmployeesRequest}
      createTimesheetLineRequest={createTimesheetLineRequest}
      editTimesheetLineRequest={editTimesheetLineRequest}
      getTimesheetRequest={getTimesheetRequest}
      submitTimesheetRequest={submitTimesheetRequest}
      reopenTimesheetRequest={reopenTimesheetRequest}
      deleteTimesheetLineRequest={deleteTimesheetLineRequest}
      importTimesheetRequest={importTimesheetRequest}
    />
  );
};
